
import { Component, Vue, Prop, Watch, Emit, Mixins } from 'vue-property-decorator'
import Title from './Title/index.vue'
import CourseCard from './CourseCard/index.vue'
import EmptyStatus from '@xt/www/components/emptyStatus/index.vue'
import { EnumEmptyStatus } from '@xt/client/utils/empty-status/index'
import { MixinsGoCourse } from '@xt/client/mixins'
import { Debounce } from 'lodash-decorators'
import { reportEntryLog } from '@xt/client/utils/log'

type MyProductStatus = {
  loading: boolean
  isError: boolean
  haveNoneCourse: boolean
}

@Component({
  components: {
    Title,
    CourseCard,
    EmptyStatus
  }
})
export default class MyCourse extends Mixins(MixinsGoCourse) {
  myProductStatus: MyProductStatus = {
    loading: true,
    haveNoneCourse: false,
    isError: false
  }

  get EnumEmptyStatus() {
    return EnumEmptyStatus
  }

  get CourseList() {
    return this.myProductList.progressingResultVOS.slice(0, 5)
  }

  setMyProductStatus(status: Partial<MyProductStatus>) {
    this.myProductStatus = {
      ...this.myProductStatus,
      ...status
    }
  }

  @Debounce(300, { leading: true, trailing: false })
  async LoadingMyProductList() {
    try {
      this.setMyProductStatus({
        loading: true
      })

      const res = await this.$store.$my.onGetMyProductList()

      this.myProductList = res

      if (this.myProductList) {
        this.setMyProductStatus({
          haveNoneCourse: Object.keys(this.myProductList).every(key => (this.myProductList[key] ?? []).length === 0)
        })
      }
      this.setMyProductStatus({
        isError: false
      })
    } catch (error) {
      reportEntryLog('toclass.loading-data.fail', { error })
      this.setMyProductStatus({
        isError: true
      })
    } finally {
      this.setMyProductStatus({
        loading: false
      })
    }
  }

  created(): void {
    this.LoadingMyProductList()
  }

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
